module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('menu-list', {
    attrs: {
      "menu": _vm.menu,
      "schema": _vm.schema,
      "showMenuIcon": _vm.showMenuIcon,
      "getElement": _vm.getElement,
      "changeToProductList": _vm.changeToProductList,
      "checkDisableItem": _vm.checkDisableItem,
      "layout": _vm.layout,
      "showProductIcon": _vm.showProductIcon,
      "checkLowerPrice": _vm.checkLowerPrice,
      "getLower": _vm.getLower,
      "openModal": _vm.openModal,
      "getIcon": _vm.getIcon,
      "getTempE": _vm.getTempE,
      "prodImgList": _vm.prodImgList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69743252"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/MenuLogic.vue
// module id = 2467
// module chunks = 1